import React from 'react'
import { social } from '../../Data/infoFooter'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BuildingOffice2Icon, PhoneIcon, ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'
import LogoBlanco from '../../Media/LogoBlanco.png'

export default function Footer() {

  const { t } = useTranslation('footer')

  const navigation = [
    {
      name: t('sections.explora'),
      links: [
        { name: t('links.nosotros'), href: '/aboutUs' },
        { name: t('links.soporte'), href: '/soporte' },
        { name: t('links.catalogo'), href: '/catalogo' },
        { name: t('links.rfid'), href: '/solutions' },
        { name: t('links.swrya'), href: '/swrya' },
      ],
    },
    {
      name: t('sections.contacto'),
      links: [
        { name: t('links.cotizacion'), href: '/contact', linkRef: 'cotizar-equipo' },
      ],
    },
  ]

  return (

    <footer className="relative bg-navy-950" aria-labelledby="footer-heading">
      <h2 id="footer-heading" className="sr-only">
        {t('footerSr')}
      </h2>
      <div
        className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-white/15 to-transparent"
        aria-hidden="true"
      />
      <div className="mx-auto max-w-7xl px-6 py-10 lg:px-8 lg:py-12">
        <div className="grid grid-cols-1 gap-x-8 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
          <div className="max-w-xs sm:col-span-2 lg:col-span-1">
            <Link to={"/"} className="flex items-center gap-3">
              <img src={LogoBlanco} alt="visiontec" className="w-32 md:w-36" />
            </Link>
            <span className="mt-4 inline-flex items-center gap-1.5 text-[11px] font-normal text-navy-400">
              <span className="relative flex h-1 w-1">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-neon-300/60 opacity-75"></span>
                <span className="relative inline-flex h-1 w-1 rounded-full bg-neon-300/70"></span>
              </span>
              {t('tagline')}
            </span>
            <p className="mt-4 text-sm leading-6 text-navy-300">
              {t('description')}
            </p>
            <div className="mt-4 flex gap-4">
              {social.map((item) => (
                <a key={item.name} href={item.href} className="text-navy-300 transition hover:text-neon-300">
                  <span className="sr-only">{item.name === 'LinkedIn' ? t('linkedinSr') : item.name}</span>
                  <item.icon className="h-5 w-5" aria-hidden="true" />
                </a>
              ))}
            </div>
          </div>

          {navigation.map((item) => (
            <div key={item.name}>
              <h3 className="text-xs font-semibold uppercase tracking-widest text-neon-300">{item.name}</h3>
              <ul className="mt-4 space-y-3">
                {item.links.map((link) => (
                  <li key={link.name}>
                    {link.placeholder ? (
                      <span
                        title="Próximamente"
                        className="cursor-not-allowed select-none text-sm leading-6 text-navy-400"
                      >
                        {link.name}
                      </span>
                    ) : link.external ? (
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm leading-6 text-navy-200 transition hover:text-neon-300"
                      >
                        {link.name}
                      </a>
                    ) : (
                      <Link
                        to={link.href}
                        state={link.linkRef}
                        className="text-sm leading-6 text-navy-200 transition hover:text-neon-300"
                      >
                        {link.name}
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="sm:col-span-2 lg:col-span-1">
            <h3 className="text-xs font-semibold uppercase tracking-widest text-neon-300">{t('contactoDirecto')}</h3>
            <ul className="mt-6 space-y-4">
              <li className="flex gap-3 text-sm leading-6 text-navy-200">
                <BuildingOffice2Icon className="h-5 w-5 flex-none text-navy-400" aria-hidden="true" />
                <span>
                  {t('address.line1')}
                  <br />
                  {t('address.line2')}
                  <br />
                  {t('address.line3')}
                </span>
              </li>
              <li className="flex gap-3 text-sm leading-6 text-navy-200">
                <PhoneIcon className="h-5 w-5 flex-none text-navy-400" aria-hidden="true" />
                <a className="transition hover:text-neon-300" href="tel:+528181294347">
                  +52 (81) 8129 4347/48
                </a>
              </li>
              <li className="flex gap-3 text-sm leading-6 text-navy-200">
                <ChatBubbleLeftRightIcon className="h-5 w-5 flex-none text-navy-400" aria-hidden="true" />
                <a className="transition hover:text-neon-300" href="https://wa.me/528118649258">
                  811 864 9258
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="mt-10 flex flex-col-reverse items-center gap-4 border-t border-white/10 pt-6 sm:flex-row sm:justify-between">
          <p className="text-xs leading-5 text-navy-400">&copy; 2026 visiontec, S.A. de C.V. {t('rightsLine')}</p>
          <Link to="/privacy" className="text-xs leading-5 text-navy-300 transition hover:text-neon-300">
            {t('privacyNotice')}
          </Link>
        </div>
      </div>
    </footer>

  )
}
